import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, } from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { PersianNumberService } from 'ngx-persian';
import { ToastrService } from 'ngx-toastr';
import { ajax } from 'rxjs/ajax';
import { AccountService } from 'src/app/services/account.service';
import { OtherService } from 'src/app/services/other.service';
import { environment } from 'src/environments/environment';
import { BusyService } from 'src/app/services/busy.service';
import axios1 from 'axios';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})

export class HomeComponent implements OnInit {
  slider: any;
  sliderVIPst: any;
  sliderVIPnd: any;
  sliderNEWst: any;
  sliderNEWnd: any;
  sliderVIP: any;
  sliderNEW: any;
  news: any = [];
  cities: any;
  telTxt: any;
  waTxt: any;
  instaTxt: any;
  emailTxt: any;
  ability: any;
  Info: any;
  txt: any;
  popAds: any;
  htmlContent: any;
  htmlContentNd: any;
  isLogin: boolean;
  diar_UserInfo: any;
  map: any;
  source: any;
  vector: any;
  layers: any = [];
  mapHeader: any;
  mapMode: any;
  vectorLayer: any;
  origin: any;
  destination: any;
  list_City: any[] = [];
  list_Type: any[] = [];
  list_PreOrder: any = [];
  lst_Drivers: any = [];
  lst_Feedback: any = [];
  lst_NewAds: any = [];
  lst_Educations: any = [];
  lst_TaxiPrice: any = [];
  bRouteModal: boolean = false;
  private strMapUrl = (<any>window).mapUrl;
  useOfflineMap = this.strMapUrl ? true : false;
  strHelp: string = '';
  obj_AppInfo: any = {};

  carouselOptions = {
    items: 1,
    rtl: true,
    loop: true,
    autoplay: true,
    autoplayTimeout: 3000, // Adjust the autoplay timeout as needed
    autoplayHoverPause: true,
    dots: true,
    nav: false, // Set to true if you want navigation arrows
    navSpeed: 700,
    navText: ['<mat-icon>قبلی</mat-icon>', `<mat-icon>بعدی</mat-icon>`],
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 2
      },
      740: {
        items: 3
      },
      940: {
        items: 4
      }
    },
  };
  carouselOptions4News = {
    items: 1,
    rtl: true,
    loop: true,
    autoplay: true,
    autoplayTimeout: 3000, // Adjust the autoplay timeout as needed
    autoplayHoverPause: true,
    dots: false,
    margin: 20,
    nav: false, // Set to true if you want navigation arrows
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 2
      },
      740: {
        items: 3
      },
      940: {
        items: 4
      }
    },
  };

  reqModel: FormGroup = this.formBuilder.group({
    tiRealEstate_Group: new FormControl(-1),
    iRealEstate_SubGroup: new FormControl(-1),
    strTitle: new FormControl(''),
    strCityCode: new FormControl(-1),
    strPriceDescription: new FormControl(''),
    strAddress: new FormControl(''),
    iPrice: new FormControl(''),
    iMortgage: new FormControl(''),
    iRent: new FormControl(''),
    iConstructionYear: new FormControl(''),
    tiFloor: new FormControl(''),
    tiRooms: new FormControl(''),
    tiBathrooms: new FormControl(''),
    tiUnitsPerFloor: new FormControl(''),
    tiParking: new FormControl(''),
    fArea: new FormControl(''),
    fLat: new FormControl(0),
    fLon: new FormControl(0),
    tiFurnishedStatus: new FormControl(0),
    strComment: new FormControl(''),
    bParking: new FormControl(false),
    bWarehouse: new FormControl(false),
    bElevator: new FormControl(false),
    bSwimmingPool: new FormControl(false),
    bBalcony: new FormControl(false),
    bKeepingPets: new FormControl(false),
    bSmoking: new FormControl(false),
    bAgreement: new FormControl(false),
    bActive: new FormControl(true),
    bVIP: new FormControl(false),
    strDischargeDate: new FormControl(''),
    strCoolingSystem: new FormControl(''),
    strFacilitiesCost: new FormControl(''),
    strHeatingSystem: new FormControl(''),
    strFireAlarmSystem: new FormControl(''),
    strStructureType: new FormControl(''),
    strPeople: new FormControl(''),
    strRentalTime: new FormControl(''),
    strAdditionalParkingFee: new FormControl(''),
  });
  mdl_TripSAD: FormGroup = this.formBuilder.group({

    strSCity: new FormControl(''),

    strSCityName: new FormControl(''),

    fSLat: new FormControl(''),

    fSLon: new FormControl(''),

    strDCity: new FormControl(''),

    strDCityName: new FormControl(''),

    fDLat: new FormControl(''),

    fDLon: new FormControl(''),

    tiMobileGroup: new FormControl(1),

    strDate: new FormControl(''),

    ObjResponse: new FormControl(),

  });

  @ViewChild('fleetContainer') fleetContainer: ElementRef;
  @ViewChild('EventContainer') EventContainer: ElementRef;
  @ViewChild('feedbackContainer') feedbackContainer: ElementRef;
  @ViewChild('adsContainer') adsContainer: ElementRef;
  @ViewChild('EducationContainer') EducationContainer: ElementRef;

  constructor(

    private accountService: AccountService,

    private router: Router,

    private otherService: OtherService,

    private toastr: ToastrService,

    private formBuilder: FormBuilder,

    private http: HttpClient,

    private route: ActivatedRoute,

    private persianNumber: PersianNumberService,

    private sanitizer: DomSanitizer,

    public loaderService: BusyService

  ) { }

  ngOnInit(): void {

    this.accountService.Taxilon_GetHelp().subscribe((data: any) => {
      this.strHelp = data;
    })

    this.otherService.setTitle('');

    this.Info = this.otherService.getLocalStorage();

    this.getListCity();

    this.getSection_Visibility();

    this.otherService.isUserLogin$.subscribe((condition) => {

      this.isLogin = condition;

    });

    // this.otherService.hasBaseInfo$.subscribe((condition) => {

    //   if (condition) {

    //     this.obj_AppInfo = this.otherService.getApp_Config();

    //   }

    // });

  }

  ngAfterViewInit() {

    const threshold = 0.5;

    const observer_1 = new IntersectionObserver((entries) => {

      entries.forEach((entry) => {

        if (entry.isIntersecting) {

          if (this.obj_AppInfo.bCurrentDriversLocation) {

            this.getDrivers()

          }

          observer_1.disconnect();

        }

      });

    }, { threshold });

    const observer_2 = new IntersectionObserver((entries) => {

      entries.forEach((entry) => {

        if (entry.isIntersecting) {

          if (this.obj_AppInfo.bNews) {

            this.getEvents();

          }


          observer_2.disconnect();

        }

      });

    }, { threshold });

    const observer_3 = new IntersectionObserver((entries) => {

      entries.forEach((entry) => {

        if (entry.isIntersecting) {

          if (this.obj_AppInfo.bPassengerExperience) {

            this.getFeedback();

          }


          observer_3.disconnect();

        }

      });

    }, { threshold });

    const observer_4 = new IntersectionObserver((entries) => {

      entries.forEach((entry) => {

        if (entry.isIntersecting) {

          if (this.obj_AppInfo.bJobs) {

            this.getAds();

          }

          observer_4.disconnect();

        }

      });

    }, { threshold });

    const observer_5 = new IntersectionObserver((entries) => {

      entries.forEach((entry) => {

        if (entry.isIntersecting) {

          if (this.obj_AppInfo.bProfessionalTraining) {

            this.getEducations();

          }


          observer_5.disconnect();

        }

      });

    }, { threshold });

    observer_1.observe(this.fleetContainer.nativeElement);

    observer_2.observe(this.EventContainer.nativeElement);

    observer_3.observe(this.feedbackContainer.nativeElement);

    observer_4.observe(this.adsContainer.nativeElement);

    observer_5.observe(this.EducationContainer.nativeElement);


  }

  ngOnDestroy() {

    this.otherService.setTitle('');

    // this.bRouteModal = false;

  }

  getListCity = async () => {

    this.accountService.TaxiLon_MobileGroup_List().subscribe((data: any) => {
      let res = JSON.parse(data.toString());
      this.list_Type = res;
    });

    this.accountService.TaxiLon_City_List().subscribe((data: any) => {

      let res = JSON.parse(data.toString());

      this.list_City = res;

    });

    this.accountService.TaxiLon_MobileGroup().subscribe((data: any) => {

      let res = JSON.parse(data.toString());

      this.lst_TaxiPrice = res;

      // console.log(res)

    });

  };

  async getSection_Visibility() {
    try {
      const response = await fetch(environment.taxiUrl + `Taxilon_BaseInfo?tiAppType=1`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
      });

      let res = await response.json();
      this.obj_AppInfo = JSON.parse(res);
    }
    catch (error) {
      console.error('Error:', error);
    }

  }

  getFeedback() {

    this.accountService.TaxiLon_Opinions().subscribe((data: any) => {

      let res = JSON.parse(data.toString());

      if (res.iResult == 0 || res.iResult == -1) return this.accountService.toastSwal('error', res.strError)

      this.lst_Feedback = res;

    });

  }

  getAds() {

    this.accountService.Taxilon_Ads_New().subscribe((data: any) => {

      let res = JSON.parse(data.toString());

      this.lst_NewAds = res;

    });

  }

  popupClick(iDyar_PopupADV: number) {
    var model = {
      iUserManager_User: this.Info?.Id || 0,

      strSession: this.Info?.session || '',

      iDyar_PopupADV: iDyar_PopupADV,
    };

    ajax
      .post(
        environment.baseUrl + `Dyar_PopupADV_Click`,
        model,

        { 'Content-type': 'application/json' }
      )
      .subscribe({
        error(err) {
          this.accountService.toastSwal(
            'error',
            'وضعیت اتصال خود را بررسی کنید'
          );
        },
      });
  }

  getSafeHtml(value: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }

  getEvents() {

    if (this.accountService.list_StoredNews.length == 0) {

      this.accountService.TaxiLon_News({ iPage: -2 }).subscribe((response) => {

        this.news = JSON.parse(response.toString());

        this.accountService.list_StoredNews = this.news;

      });

    }

    if (this.accountService.list_StoredNews.length != 0) {

      this.news = this.accountService.list_StoredNews;
    }

  }

  openDetail(item: any, index: number) {
    window.open(
      `dyar/ads/${item.iAdvertising}/${item.iMainKey}/${item.tiType}`,
      '_blank'
    );
  }

  openSearch(tiType: number, item?: any) {
    if (item) {
      var selectedCity = {
        strCityCode: item.CityCode.trim(),

        strCityName: item.strCityName.trim(),
      };

      localStorage.removeItem('dc30al1i7rez0ab02');

      localStorage.setItem(
        'dc30al1i7rez0ab02',
        this.accountService.encrypt(JSON.stringify(selectedCity))
      );

      this.otherService.changeUserSelectedCity_Status(true);
    }

    if (tiType == 3) return this.router.navigate([`dyar/business`]);

    this.accountService.list_StoredAds = [];

    this.accountService.tiType_Stored = -3; // any digit to remove current tiType_Stored

    this.router.navigate([`dyar/search/${tiType}`]);
  }

  reDirect(url) {
    this.router.navigate([`taxilon/${url}`]);
  }

  subString_Title(text: string, limit?: number) {
    if (limit && text?.length > limit) text = text.slice(0, limit) + '...';

    if (!limit && text?.length > 55) text = text.slice(0, 55) + '...';

    return text;
  }

  openNews(iNews: number) {
    window.open(`/taxilon/News/${iNews}`, '_blank');
  }

  serviceCalc() {
    let model = this.mdl_TripSAD.value;

    if (model.strSCity == "") {
      return this.accountService.toastSwal('error', 'شهر مبدا را وارد کنید');
    }

    if (model.strDCity == "") {
      return this.accountService.toastSwal('error', 'شهر مقصد را وارد کنید');
    }
    this.accountService.TaxiLon_User_TravelCostEstimate(model).subscribe((data) => {
      let res = JSON.parse(data.toString());
      this.list_PreOrder = res;
      this.showHelp();
    });
  }

  login(redirectTo: string) {
    this.router.navigate([`/taxilon/login/${redirectTo}`]);
  }

  returnStrValue(
    strKey: string,
    strKeyValue: number | string,
    lst_: [] | any,
    strComment: string
  ): string {
    return this.otherService.initialFilterValue(
      strKey,
      strKeyValue,
      lst_,
      strComment
    );
  }

  getDrivers() {
    this.accountService.getTaxiLon_Drivers().subscribe((data: any) => {
      this.lst_Drivers = data;
    });
  }

  setValue_filter(strValue: 'strSCity' | 'strDCity', event: any) {

    this.list_PreOrder = [];

    if (strValue == 'strSCity') {

      this.mdl_TripSAD.get('strSCity')?.setValue(event?.strCity ? event.strCity : '');

      this.mdl_TripSAD.get('strSCityName')?.setValue(event?.strCityName ? event.strCityName : '');

      this.mdl_TripSAD.get('fSLat')?.setValue(event?.fLat ? event.fLat : '');

      this.mdl_TripSAD.get('fSLon')?.setValue(event?.fLon ? event.fLon : '');

    }

    else {

      this.mdl_TripSAD.get('strDCity')?.setValue(event?.strCity ? event.strCity : '');

      this.mdl_TripSAD.get('strDCityName')?.setValue(event?.strCityName ? event.strCityName : '');

      this.mdl_TripSAD.get('fDLat')?.setValue(event?.fLat ? event.fLat : '');

      this.mdl_TripSAD.get('fDLon')?.setValue(event?.fLon ? event.fLon : '');

    }

  }

  isRoute_Hide(): boolean {
    const requiredFields = [
      { key: "strSCity", isValid: (value: any) => value !== '' },
      { key: "fSLon", isValid: (value: any) => value !== '' && value !== 0 },
      { key: "fSLat", isValid: (value: any) => value !== '' && value !== 0 },
      { key: "strDCity", isValid: (value: any) => value !== '' },
      { key: "fDLon", isValid: (value: any) => value !== '' && value !== 0 },
      { key: "fDLat", isValid: (value: any) => value !== '' && value !== 0 },
    ];

    return !requiredFields.some(field => !field.isValid(this.mdl_TripSAD.value[field.key]));

  }

  openRoute() {

    var model = this.mdl_TripSAD.value;

    this.loaderService.busy();

    const api = 'https://api.openrouteservice.org/v2/directions/driving-car';

    const apiKey = '5b3ce3597851110001cf6248f929f5c0617b429ba92f0e10df39ced9';

    const apiUrl = `${api}?api_key=${apiKey}&start=${model.fSLon},${model.fSLat}&end=${model.fDLon},${model.fDLat}`;

    axios1.get(apiUrl).then(response => {

      this.loaderService.idle();

      this.mdl_TripSAD.get('ObjResponse')?.setValue(response);

      this.bRouteModal = true;

    }).catch(error => {

      this.loaderService.idle();

      this.accountService.toastSwal('error', 'خطایی در دریافت اطلاعات رخ داده است')

      console.error('Error fetching route:', error);

    });


  }

  showAds(item) {

    window.open(`/taxilon/job/${this.convertSpaceTo_(item.strTitle, '-')}/${item.iTaxilon_Advertisement}`, '_blank')

  }

  convertSpaceTo_(strTitle, symbol?: string): string {

    return strTitle.trim().replace(/[\s\/\-*]+|or/g, symbol ? symbol : "_");

    return strTitle.trim().replace(/ /g, symbol ? symbol : "_")

  }

  getEducations() {

    this.accountService.Educational_List().subscribe((data: any) => {

      let res = JSON.parse(data.toString())

      res.forEach((el: any, index: number) => {

        res[index].strContentPath = this.return_SafeUrl(el.strContentPath);

      })

      this.lst_Educations = res;

    });

  }

  return_SafeUrl(url: string) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  showHelp() {
    if (this.strHelp) {
      Swal.fire({
        title: this.strHelp,
        icon: 'warning',
        iconHtml: '!',
        showCancelButton: false,
        showConfirmButton: true,
        reverseButtons: true,
        confirmButtonColor: '#10b981',
        cancelButtonColor: '#EF4444',
        confirmButtonText: '!متوجه شدم',
      })
    }
  }


}
